export const DealerPendingActionTypes = {
  LANDLINE_PHONE_NUMBER_CHANGE: 'LANDLINE_PHONE_NUMBER_CHANGE',
  PHONE_NUMBER_CHANGE: 'PHONE_NUMBER_CHANGE',
  MAIN_LOCATION_CHANGE: 'MAIN_LOCATION_CHANGE',
  ADD_ADDITIONAL_LOCATION: 'ADD_ADDITIONAL_LOCATION',
};
